import React, { useState } from 'react';

import PlayerCard from '../../../cards/PlayerCard';

import { sportTypeIds } from '../../../../utils/eventConstants';

const FREE_PLAY_EVENT_TYPE = 4;
const statuses = [
    { label: 'Confirmed', value: 'Accepted' },
    { label: 'Invited', value: 'Invited' },
    { label: 'Declined', value: 'Declined' },
];

const accepted = 'Accepted';
const invited = 'Invited';
const declined = 'Declined';

const PlayersList = ({ event }) => {
    const { invites, eventType, registeredPlayers, sportTypeId } = event;
    const hasInvites = invites?.members?.length > 0;
    const hasRegisteredPlayers = registeredPlayers.length > 0;
    const isCurrentMemberPlaying = event && event.currentMember.isPlaying;
    const [status, setStatus] = useState('Accepted');
    let mappedInvites;

    if (hasInvites && eventType.id === FREE_PLAY_EVENT_TYPE) {
        mappedInvites = invites.members.map(member => {
            return { ...member, id: member.playerId };
        });
    }
    return (
        <div>
            <h6 className="text-uppercase">
                Players
            </h6>
            <div className="div mb16" />
            <div>
                {statuses.map(stat => (
                    <button
                        type="button"
                        className={`btn btn-${stat.value === status ? 'primary' : 'default'} text-uppercase mr16 mb8`}
                        onClick={() => setStatus(stat.value)}
                    >
                        {stat.label}
                    </button>
                ))}
            </div>
            <div className="div mt8" />

            {hasRegisteredPlayers && status === accepted &&
                registeredPlayers.map(player => (
                    <PlayerCard
                        player={player}
                        utrType={event.utrType.value}
                        showDecimals={isCurrentMemberPlaying}
                        hideRatings={false}
                        showPickleBallRatings={parseInt(sportTypeId) === sportTypeIds.PICKLEBALL || false}
                        showTennisRatings={parseInt(sportTypeId) === sportTypeIds.TENNIS || false}
                    />
                ))}
            {hasInvites && (status === declined || status === invited) && (
                mappedInvites.map(player => {
                    if (player.status === status) {
                        return (
                            <PlayerCard
                                player={player}
                                utrType={event.utrType.value}
                                showDecimals={isCurrentMemberPlaying}
                                hideRatings={false}
                                showPickleBallRatings={parseInt(sportTypeId) === sportTypeIds.PICKLEBALL || false}
                                showTennisRatings={parseInt(sportTypeId) === sportTypeIds.TENNIS || false}
                            />
                        );
                    }
                    return null;
                }))}

        </div>
    );
};

export default PlayersList;
